import { Product } from '../ecommerce/DtoProduct';
import { ProductQuantity } from '../ecommerce/DtoProductQuantity';
import { ProductType } from '../ecommerce/ProductType';

export interface DtoAddon {
    product: Product;
    quantity: ProductQuantity;
}

export class Addon implements DtoAddon {
    product!: Product;
    quantity!: ProductQuantity;
    isMember!: boolean;

    constructor(dtoAddon: DtoAddon, isMember?: boolean) {
        this.product = dtoAddon.product;
        this.quantity = dtoAddon.quantity;
        this.isMember = isMember || false;
    }

    get productPrice() {
        return this.product.getProductPrice(this.isMember);
    }

    get addonSubTotal() {
        if (this.product.productType == ProductType.Donation) {
            return this.quantity.price;
        }
        else {
            return this.productPrice * this.quantity.quantity;
        } 
    }
}

export function createAddon(dtoAddon: DtoAddon, isMember?: boolean) {
    return new Addon(dtoAddon, isMember);
}
